<template>
	<nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);">
		<ol class="breadcrumb border-bottom p-3">
			<li class="breadcrumb-item">
				<router-link :to="{path: '/'}" class="text-decoration-none">Главная</router-link>
			</li>
			<li class="breadcrumb-item">
				<router-link :to="{path: '/projects'}" class="text-decoration-none">Проекты</router-link>
			</li>
			<li class="breadcrumb-item active">Изменение проекта</li>
		</ol>
	</nav>
	<div class="container-fluid">
		<div class="mb-3">
			<h5>Изменение проекта</h5>
			<div class="text-muted">Редактирование информации о проекте с указанием прав доступа пользователям и группам пользователей</div>
		</div>
		<div class="d-flex justify-content-center mt-5" v-if="init">
			<div class="spinner-border" style="width: 100px; height: 100px;"></div>
		</div>
		<div class="d-flex justify-content-center mt-5" v-if="!init && !project.id">
			<div class="text-center">
				<h4 class="text-uppercase mt-4">404</h4>
				<p class="text-muted">Проект не найден</p>
				<div class="mt-4">
					<router-link :to="{path: '/projects'}" class="btn btn-primary waves-effect waves-light">Перейти к списку</router-link>
				</div>
			</div>
		</div>
		<form @submit.prevent="saveChanges" v-if="!init && project.id">
			<div class="row">
				<div class="col-md-2 mb-3">
					<div class="card">
						<div class="card-header">Иконка</div>
						<div class="card-body text-center">
							<div v-if="previewIcon || oldIcon">
								<image-with-placeholder
									:src="previewIcon || oldIcon"
									class="mw-100 ratio ratio-1x1 rounded mb-2"
									height="100%"
									skeleton="shimmer"
									alt="icon"
								/>
							</div>
							<div>
								<img src="/assets/images/noimage1.png" />
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-5 mb-3">
					<div class="card">
						<div class="card-header">Параметры проекта</div>
						<div class="card-body">
							<div class="mb-3">
								<label for="inputName" class="form-label">Название *</label>
								<input ref="projectNameInput" class="form-control" type="text" id="inputName" v-model="project.name" :disabled="loading" required  />
							</div>
							<div class="mb-3">
								<label for="inputApiname" class="form-label">API Name *</label>
								<input class="form-control font-monospace" type="text" id="inputApiname" v-model="project.apiname" :disabled="loading" required />
							</div>
							<div class="mb-3">
								<label for="selectRepo" class="form-label">Репозиторий *</label>
								<select class="form-select" id="selectRepo" v-model="project.repo" disabled>
									<option :value="repo.repo" v-for="repo in repos">{{repo.name}}</option>
								</select>
							</div>
							<div class="mb-2 row">
								<div class="col-4">
									<label class="form-check-label" for="switchAutoMergeEnabled">Включить auto merge?</label>
									<div class="form-check form-switch">
										<input class="form-check-input" type="checkbox" role="switch" id="switchAutoMergeEnabled" :disabled="loading" v-model="project.autoMergeEnabled" />
									</div>
								</div>
								<div class="col-4"></div>
								<div class="col-4">
									<label for="inputRequiredApprovals" class="form-label">Кол-во обязательных approvals *</label>
									<input class="form-control" type="number" id="inputRequiredApprovals" :disabled="loading" v-model.number="project.requiredApprovals" required />
								</div>
							</div>
							<div>
								<label for="inputIcon" class="form-label">Иконка</label>
								<input ref="fileInput" class="form-control" type="file" id="inputIcon" accept="image/*" @change="onFileChange" :disabled="loading" />
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-5 mb-3">
					<div class="card">
						<div class="card-header">Права доступа</div>
						<div class="card-body">
							<div class="input-group mb-3">
								<input type="text" class="form-control" placeholder="Поиск по пользователям и группам" v-model="search" :disabled="loading" />
								<button class="btn btn-outline-secondary d-flex align-items-center px-2" type="button" :disabled="loading" @click="search = ''" v-if="search">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
										<path d="M16.24,3.56L21.19,8.5C21.97,9.29 21.97,10.55 21.19,11.34L12,20.53C10.44,22.09 7.91,22.09 6.34,20.53L2.81,17C2.03,16.21 2.03,14.95 2.81,14.16L13.41,3.56C14.2,2.78 15.46,2.78 16.24,3.56M4.22,15.58L7.76,19.11C8.54,19.9 9.8,19.9 10.59,19.11L14.12,15.58L9.17,10.63L4.22,15.58Z" />
									</svg>
								</button>
							</div>
							<div>
								<div class="form-check">
									<input
										class="form-check-input"
										type="checkbox"
										id="checkGroupAll"
										:checked="project.users.length === users.length"
										@change="toggleAllUsers"
										:disabled="loading"
									/>
									<label for="checkGroupAll" class="badge text-bg-primary font-monospace">@all</label>
								</div>
								<div class="ms-4">
									<div class="form-check" v-for="user in filteredUsers" :key="user.id">
										<input class="form-check-input" type="checkbox" :value="user.id" :id="'checkGroupAllUser' + user.id" :disabled="loading" v-model="project.users" />
										<label :for="'checkGroupAllUser' + user.id">
											<code>{{ user.login }}</code>
										</label>
									</div>
								</div>
							</div>
							<div v-for="group in filteredGroups" :key="group.id">
								<div class="form-check">
									<input class="form-check-input" type="checkbox" :value="group.id" :id="'checkGroup' + group.id" :disabled="loading" v-model="project.groups" />
									<label class="badge text-bg-dark font-monospace" :for="'checkGroup' + group.id">@{{ group.name }}</label>
								</div>
								<div class="ms-4">
									<div class="form-check" v-for="user in group.users" :key="user.id">
										<input class="form-check-input" type="checkbox" :value="user.id" :id="'checkGroup' + group.id + 'User' + user.id" :checked="hasCheckedGroup(group.id)" disabled />
										<label :for="'checkGroup' + group.id + 'User' + user.id">
											<code>{{ user.login }}</code>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="card">
				<div class="card-body">
					<div class="d-grid gap-2 d-md-flex justify-content-md-between">
						<button
							type="button"
							class="btn btn-danger d-flex align-items-center justify-content-center"
							@click="deleteProject"
							:disabled="loading"
						>
							<span v-if="loading && loadingDelete" class="spinner-border spinner-border-sm me-2"></span>
							<svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
								<path d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z" />
							</svg>
							<span class="ms-2">{{ loading && loadingDelete ? 'Удаление...' : 'Удалить проект' }}</span>
						</button>
						<a
							:href="`/${project.repo}/${project.apiname}`"
							class="btn btn-secondary d-flex align-items-center justify-content-center"
							:disabled="loading"
						>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
								<path v-if="project.repo == 'hg'" d="M10.66 17c.22.84.08 1.74-.38 2.48a3.174 3.174 0 0 1-5.9-.62c-.22-.84-.08-1.74.38-2.48a3.174 3.174 0 0 1 5.9.62m-5.14-4.46c.51-.56.62-1.48.45-2A2.07 2.07 0 0 0 3.42 9.1c-.58.16-1.05.56-1.31 1.1-.62.97-.33 2.25.64 2.86.92.59 2.14.36 2.78-.52M12.1 2.08c-2.63.33-4.33 1.53-5.12 3.03-1.65 2.68-.26 6.44 4 7.65 5.58 1.58 1.15 5.12 1.28 7.48s4.85 3.21 8.57-2.98c.07-.12.14-.24.2-.36 3.53-6.08-.89-15.81-8.93-14.81"/>
								<path v-if="project.repo == 'git'" d="M2.6,10.59L8.38,4.8L10.07,6.5C9.83,7.35 10.22,8.28 11,8.73V14.27C10.4,14.61 10,15.26 10,16A2,2 0 0,0 12,18A2,2 0 0,0 14,16C14,15.26 13.6,14.61 13,14.27V9.41L15.07,11.5C15,11.65 15,11.82 15,12A2,2 0 0,0 17,14A2,2 0 0,0 19,12A2,2 0 0,0 17,10C16.82,10 16.65,10 16.5,10.07L13.93,7.5C14.19,6.57 13.71,5.55 12.78,5.16C12.35,5 11.9,4.96 11.5,5.07L9.8,3.38L10.59,2.6C11.37,1.81 12.63,1.81 13.41,2.6L21.4,10.59C22.19,11.37 22.19,12.63 21.4,13.41L13.41,21.4C12.63,22.19 11.37,22.19 10.59,21.4L2.6,13.41C1.81,12.63 1.81,11.37 2.6,10.59Z" />
							</svg>
							<span class="ms-2">{{ project.repo == 'hg' ? 'Mercurial (HG)' : 'Git' }}</span>
						</a>
						<button
							type="submit"
							class="btn btn-primary d-flex align-items-center justify-content-center"
							:disabled="loading"
						>
							<span v-if="loading && loadingSave" class="spinner-border spinner-border-sm me-2"></span>
							<svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
								<path d="M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z" />
							</svg>
							<span class="ms-2">{{ loading && loadingSave ? 'Сохранение...' : 'Сохранить изменения' }}</span>
						</button>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';
import { useModal } from "vue-final-modal";

import ImageWithPlaceholder from '@/components/ImageWithPlaceholder.vue';
import BootstrapConfirmModal from "@/components/modals/BootstrapConfirmModal.vue";

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Изменение проекта | SKV'});
	},
	data: () => ({
		init: false,
		loading: false,
		loadingSave: false,
		loadingDelete: false,
		repos: [
			{
				repo: 'hg',
				name: 'Mercurial (HG)',
			},
			{
				repo: 'git',
				name: 'Git',
			},
		],
		users: [],
		groups: [],
		search: '',
		previewIcon: '',
		oldIcon: '',
		selectedFile: null,
		project: {
			id: null,
			name: '',
			apiname: '',
			repo: 'hg',
			requiredApprovals: 1,
			autoMergeEnabled: false,
			users: [],
			groups: [],
		},
	}),
	computed: {
		filteredUsers(){
			const search = this.search.toLowerCase();
			return this.users.filter(user => user.login.toLowerCase().includes(search));
		},
		filteredGroups(){
			const search = this.search.toLowerCase();
			return this.groups.filter(group => group.name.toLowerCase().includes(search));
		},
	},
	methods: {
		getIcon(project) {
			if (!project?.icon) return '';
			return `/files/projects/${project.repotype}/${project.icon}`;
		},
		hasCheckedGroup(groupId){
			return this.project.groups.includes(groupId);
		},
		toggleAllUsers(event){
			this.project.users = event.target.checked ? this.users.map(u => u.id) : [];
		},
		
		onFileChange(e) {
			const file = e.target.files[0];
			if (!file || !file.type.match('image.*')) {
				if (file) alert('Пожалуйста, выберите изображение');
				this.resetFile();
				return;
			}

			this.selectedFile = file; // Сохраняем "модель"
			if (this.previewIcon) URL.revokeObjectURL(this.previewIcon);
			this.previewIcon = URL.createObjectURL(file);
		},
		resetFile() {
			this.selectedFile = null;
			this.previewIcon = '';
			if (this.$refs.fileInput) {
				this.$refs.fileInput.value = ''; // Очистка системного инпута
			}
		},
		async loadData() {
			this.loading = true;
			try {
				const projectId = this.$route.params.id;
				// Загружаем всё параллельно: пользователей, группы и сам проект
				const [users, groups, projectRes] = await Promise.all([
					this.appModel.doGetUsers({all: true}),
					this.appModel.doGetUserGroups({all: true}),
					this.appModel.doGetProject(projectId),
				]);
				this.users = users.list || [];
				this.groups = groups.list || [];
				
				// Преобразуем полученные данные группы под формат чекбоксов (массивы ID)
				if (projectRes) {
					this.project = {
						id: projectRes.id,
						name: projectRes.name,
						apiname: projectRes.apiname,
						repo: projectRes.repotype,
						autoMergeEnabled: projectRes.auto_merge_enabled,
						requiredApprovals: projectRes.required_approvals,
						users: projectRes.direct_users.map(p => p.id),
						groups: projectRes.groups.map(p => p.id),
					};
					this.oldIcon = this.getIcon(projectRes);
				}
			} catch (e) {
				console.error(e);
			} finally {
				this.loading = false;
			}
		},
		
		async saveChanges() {
			this.loading = true;
			this.loadingSave = true;
			try {
				const formData = new FormData();
				
				formData.append('id', this.project.id);
				formData.append('name', this.project.name);
				formData.append('apiname', this.project.apiname);
				formData.append('repo', this.project.repo);
				formData.append('auto_merge_enabled', this.project.autoMergeEnabled ? 1 : 0);
				formData.append('required_approvals', this.project.requiredApprovals);
				
				if (this.selectedFile) {
					formData.append('icon_file', this.selectedFile);
				}

				this.project.users?.forEach(id => {
					formData.append('users[]', id);
				});

				this.project.groups?.forEach(id => {
					formData.append('groups[]', id);
				});

				const result = await this.appModel.doEditProject(this.project.id, formData);
				if (!result.success) {
					this.$toast.error(result.message);
				}
			} finally {
				this.loading = false;
				this.loadingSave = false;
			}
		},
		deleteProject() {
			useModal({
				component: BootstrapConfirmModal,
				attrs: {
					title: "Удаление проекта",
					centered: true,
					confirmText: "Удалить проект",
					confirmColor: "danger",
					onConfirm: async () => {
						this.loading = true;
						this.loadingDelete = true;
						try {
							const result = await this.appModel.doDeleteProject(this.project.id);
							if (result.success) {
								await this.appModel.refreshCounts();
								
								this.$router.push('/projects');
							} else {
								this.$toast.error(result.message);
							}
						} finally {
							this.loading = false;
							this.loadingDelete = false;
						}
					},
				},
				slots: {
					default: `Вы уверены, что хотите безвозвратно удалить проект "${this.project.name} (${this.project.apiname})"?`,
				},
			}).open();
		},
	},
	async mounted() {
		this.init = true;
		await this.loadData();
		this.init = false;
		
		this.$nextTick(() => {
			this.$refs.projectNameInput?.focus();
		});
	},
	components: {
		ImageWithPlaceholder,
	},
};
</script>
